import * as React from 'react';
import { Button, Image, Grid, Label } from 'semantic-ui-react';



const LoginTipo = (props) => {
    const { onChange, tipoAtendimento } = props;
    return (
        <Grid columns={2} centered >
            <Grid.Row className='gridcolumnTipoLogin' centered>
                <Grid.Column className='colunaTipoLogin'>
                    <Button className={tipoAtendimento === 0 ? 'loginTipoAtendimentoToggle' : 'loginTipoAtendimento'} onClick={() => onChange(0)}>
                        <Image src={require('../img/paciente.png')} verticalAlign='middle' />
                        <Label >Beneficiario</Label>
                    </Button>
                </Grid.Column>
                <Grid.Column  className='colunaTipoLogin'>
                    <Button className={tipoAtendimento === 1 ? 'loginTipoAtendimentoToggle' : 'loginTipoAtendimento'} onClick={() => onChange(1)}>
                        <Image src={require('../img/medico2.png')} verticalAlign='middle' />
                        <Label >Médico</Label>
                    </Button>
                </Grid.Column>
            </Grid.Row>
        </Grid>

    );
}

export default LoginTipo;